import { render, staticRenderFns } from "./DetailsInfo.vue?vue&type=template&id=60a8cd61&"
import script from "./DetailsInfo.vue?vue&type=script&lang=ts&"
export * from "./DetailsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports